import React, { useEffect, useState } from "react";
import { Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import SideDrawer from "../../components/Comman/Drawer/SideDrawer";
import Button from "../../components/Button/Button";
import { categoryList, deleteCategory } from "../../actions/admin";
import ConfirmDeleteModal from "../../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";

const Category = () => {
  const dispatch = useDispatch<any>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [deleteModelVisible, setDeleteModelVisible] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchCategoryList = (params = {}) => {
    setLoading(true);
    dispatch(
      categoryList(params, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setData(resp?.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    fetchCategoryList({
      page: pagination.current,
      limit: pagination.pageSize,
    });
  }, [pagination?.current, pagination?.pageSize, handleRefresh]);

  const handleIsModelOpen: any = () => {
    setIsModalOpen(!isModalOpen);
    setSelectedCategory({});
  };

  const handleEditClick = (record: any) => {
    handleIsModelOpen();
    setSelectedCategory(record); // Store the selected category's data
  };

  const handleTableChange = (newPagination: any) => {
    setPagination({
      ...pagination,
      current: newPagination?.current,
      pageSize: newPagination?.pageSize,
    });
  };

  const handleDeleteModel = (id?: number) => {
    if (id) setSelectedUserId(id); // Store the selected user ID
    setDeleteModelVisible(!deleteModelVisible);
  };

  const handleBudgetDeletion = () => {
    setLoading(true); // Show loading indicator before making the API call
    dispatch(
      deleteCategory(selectedUserId, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          // User deleted successfully, handle UI update if needed
          handleDeleteModel();
        } else {
          handleDeleteModel();
        }
      })
    );
  };

  const columns = [
    {
      title: "Category Code",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Category Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EditOutlined
              onClick={() => {
                handleEditClick(record);
              }}
            />
          </span>
          {/* <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EyeOutlined />
          </span> */}
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <DeleteOutlined onClick={() => handleDeleteModel(record?.id)} />
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Header /> */}
      <div className="flex justify-between">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Categories
        </h1>
        <div>
          <Button
            buttonText="Create Category"
            padding="p-[12px] 2xl:p-[15px]"
            text="text-[12px]"
            handleIsModelOpen={handleIsModelOpen}
            type="button"
          />
        </div>
      </div>
      <div className="table-col">
        <DataTable
          columns={columns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
      <SideDrawer
        open={isModalOpen}
        onClose={handleIsModelOpen}
        type={"category"}
        organizationData={selectedCategory}
      />
      {deleteModelVisible && (
        <ConfirmDeleteModal
          handleConfirmDeleteModel={handleDeleteModel}
          type="delete"
          handleModelFunction={handleBudgetDeletion}
        />
      )}
    </div>
  );
};

export default Category;
